// app/javascript/controllers/toast_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    from:        { type: String, default: "tw--translate-x-full" },
    to:          { type: String, default: "tw-translate-x-0" },
    durationClass: { type: String, default: "tw-duration-300" },
    easingClass:   { type: String, default: "tw-ease-out" },
    delayClass:    { type: String, default: "tw-delay-0" },
    autoDismiss:        { type: Boolean, default: false },
    autoDismissTimeout: { type: Number, default: 4000 },
  }

  connect() {
    // 1) Apply initial state
    this.fromValue.split(" ").forEach(translateClass => {
      this.element.classList.add(translateClass);
    });

    // 2) Force a reflow so the browser registers the initial transform
    void this.element.offsetHeight;

    // 3) Add transition utilities
    this.element.classList.add(
      "tw-transition", "tw-transform",
      this.durationClassValue,
      this.easingClassValue,
      this.delayClassValue
    );

    // 4) After JS delay, swap out translate classes to animate entry
    requestAnimationFrame(() => {
      this.fromValue.split(" ").forEach(translateClass => {
        this.element.classList.remove(translateClass);
      });
      if (this.hasToValue) {
        this.toValue.split(" ").forEach(translateClass => {
          this.element.classList.add(translateClass);
        });
      }
    });

    // 5) Schedule auto-dismiss if enabled
    if (this.autoDismissValue) {
      this.dismissTimer = setTimeout(() => this.dismiss(), this.autoDismissTimeoutValue);
    }
  }

  disconnect() {
    clearTimeout(this.dismissTimer);
  }

  dismiss() {
    // Reverse translate for exit
    if (this.hasToValue) {
      this.toValue.split(" ").forEach(translateClass => {
        this.element.classList.remove(translateClass);
      });
    }
    this.fromValue.split(" ").forEach(translateClass => {
      this.element.classList.add(translateClass);
    });

    // Remove element after the CSS transition duration
    const durationMs = parseInt(this.durationClassValue.match(/\d+/)[0], 10);
    setTimeout(() => this.element.remove(), durationMs);
  }
}
